export type CookieConsent = 'accepted' | 'rejected'

const STORAGE_KEY = 'longy.cookieConsent'
const CONSENT_CHANGE_EVENT = 'longy:cookie-consent-change'

export const readCookieConsent = (): CookieConsent | null => {
    if (typeof window === 'undefined') return null
    try {
        const value = window.localStorage.getItem(STORAGE_KEY)
        return value === 'accepted' || value === 'rejected' ? value : null
    } catch {
        return null
    }
}

export const writeCookieConsent = (value: CookieConsent) => {
    if (typeof window === 'undefined') return
    try {
        window.localStorage.setItem(STORAGE_KEY, value)
    } catch {
        // localStorage may be unavailable (privacy mode, blocked storage)
    }
    window.dispatchEvent(new CustomEvent<CookieConsent>(CONSENT_CHANGE_EVENT, { detail: value }))
}

export const subscribeCookieConsent = (
    listener: (value: CookieConsent | null) => void,
): (() => void) => {
    if (typeof window === 'undefined') return () => undefined

    const handleChange = (event: Event) => {
        const detail = (event as CustomEvent<CookieConsent>).detail
        listener(detail ?? readCookieConsent())
    }
    const handleStorage = (event: StorageEvent) => {
        if (event.key === STORAGE_KEY) listener(readCookieConsent())
    }

    window.addEventListener(CONSENT_CHANGE_EVENT, handleChange)
    window.addEventListener('storage', handleStorage)

    return () => {
        window.removeEventListener(CONSENT_CHANGE_EVENT, handleChange)
        window.removeEventListener('storage', handleStorage)
    }
}
